

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Chart from 'chart.js/auto';
import Itg from './ITG_BLANCO.png'  
import ItgNegro from './ITG-Logo-Negro.png'  
import Scapp from './logo_scapp_blanco.png'  
import ScappNegro from './logo_scapp_negro.png'  


function normalizeColor(color) {
  if (!color) return [150, 150, 150];
  if (Array.isArray(color)) return normalizeColor(color[0]);
  if (typeof color === 'string' && color.startsWith('rgb')) {
    const values = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',').map(v => parseFloat(v));
    return values.slice(0, 3);
  }
  if (typeof color === 'string' && color.startsWith('#')) {
    let hex = color.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
    const bigint = parseInt(hex, 16);
    return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
  }
  return [150, 150, 150];
}

function filterChartDataForPDF(originalData) {
  const validIndexes = (originalData.labels || []).map((_, i) => {
    return (originalData.datasets || []).some(ds => {
      const v = Array.isArray(ds.data) ? ds.data[i] : undefined;
      // return v !== 0 && v !== null && v !== undefined; FILTRANDO 0
      return v !== null && v !== undefined;
    });
  });
  return {
    labels: (originalData.labels || []).filter((_, i) => validIndexes[i]),
    datasets: (originalData.datasets || []).map(ds => ({
      ...ds,
      data: (ds.data || []).filter((_, i) => validIndexes[i])
    }))
  };
}

const loadImageBase64 = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.crossOrigin = 'Anonymous';
  img.src = src;
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width; canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    resolve(canvas.toDataURL('image/png'));
  };
  img.onerror = reject;
});



export async function exportToPDFIndividual(chart, opts = {}) {
  if (!chart) { console.error('exportToPDF: chart null'); return; }

  const {
    darkModePDF = false,
    title ,
    invert = true,
    splitByMetric = true,            // ← un gráfico por métrica
    respectVisibility = true,        // ← respeta lo visible en pantalla
    visibleDatasetLabels = [],       // ← pasar desde el botón usando chart.isDatasetVisible(i)
    fileName = 'Reporte_por_metrica.pdf',
    pdfOrientation = 'landscape',
    horizontalLinePlugin,
    onProgress
  } = opts;

  const MAX_COLUMNS = invert ? 12 : 24;           // (se mantiene para tablas anchas)
  const HEADER_HEIGHT = 60;
  const PAD = 12;

  try {
    // ---- Logos según modo ----
    // const itg = isElectron() ? `${window.location.origin}/images/ITG_BLANCO.png`
    //                          : process.env.PUBLIC_URL + `/images/ITG_BLANCO.png`;
    // const itgNegro = isElectron() ? `${window.location.origin}/images/ITG-Logo-Negro.png`
    //                               : process.env.PUBLIC_URL + `/images/ITG-Logo-Negro.png`;
    // const scapp = isElectron() ? `${window.location.origin}/images/logo_scapp_blanco.png`
    //                            : process.env.PUBLIC_URL + `/images/logo_scapp_blanco.png`;
    // const scappNegro = isElectron() ? `${window.location.origin}/images/logo_scapp_negro.png`
    //                                 : process.env.PUBLIC_URL + `/images/logo_scapp_negro.png`;

    // const logoITGPath = darkModePDF ? itg : itgNegro;
    // const logoSCAPPPath = darkModePDF ? scapp : scappNegro;
    const itg = Itg
    const itgNegro = ItgNegro
    const scapp = Scapp
    const scappNegro = ScappNegro
    const logoITGPath = darkModePDF ? itg : itgNegro;
    const logoSCAPPPath = darkModePDF ? scapp : scappNegro;

    const [logoITG, logoSCAPP] = await Promise.all([
      loadImageBase64(logoITGPath),
      loadImageBase64(logoSCAPPPath),
    ]);

    // ---- Datos del chart ----
    const originalData = chart?.config?.data || {};
    const filteredAllData = filterChartDataForPDF(originalData);

    // ---- Selección de datasets para el PDF (según visibilidad) ----
    let datasetsForPDF = filteredAllData.datasets || [];
    if (respectVisibility && Array.isArray(visibleDatasetLabels) && visibleDatasetLabels.length) {
      const allow = new Set(visibleDatasetLabels);
      const onlyVisible = datasetsForPDF.filter(ds => allow.has(ds.label));
      if (onlyVisible.length) datasetsForPDF = onlyVisible;
    }
    // fallback: si no queda ninguno, exportamos todos para evitar PDF vacío
    if (!datasetsForPDF.length) datasetsForPDF = filteredAllData.datasets || [];

    // ---- PDF base ----
    const pdf = new jsPDF({ orientation: pdfOrientation, unit: 'pt', format: 'a4' });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const pageBackground = darkModePDF ? '#1e1e1e' : '#ffffff';
    const textColor = darkModePDF ? '#ffffff' : '#000000';
    const gridColor = darkModePDF ? '#444444' : 'rgba(0,0,0,0.3)';
    const axisColor = darkModePDF ? '#ffffff' : '#000000';

    const paintBG = () => { pdf.setFillColor(pageBackground); pdf.rect(0, 0, pageWidth, pageHeight, 'F'); };
    const paintHeader = () => {
      const itgW = 70, scappW = 120;
      const itgY = (HEADER_HEIGHT - 40) / 2;
      const scappY = (HEADER_HEIGHT - 30) / 2 + 9;
      pdf.addImage(logoITG, 'PNG', 40, itgY, itgW, 0);
      pdf.addImage(logoSCAPP, 'PNG', pageWidth - scappW - 40, scappY, scappW, 0);
    };

    const getMetricInfo = (ds) => {
      // preferir metadatos del dataset
      const chartTitle =  'SFR [ % ]';
      const yAxis = ds.unit || ds.yLabel || ds.metricName || ds.label || 'Valor';
      return { chartTitle, yAxis };
    };

    // ---- Render de un bloque (gráfico + tablas) para 1 métrica ----
    const paintMetricBlock = async (dataset, allLabels) => {

      const { chartTitle, yAxis } = getMetricInfo(dataset);

      // 1) página: fondo + header + título
      paintBG(); paintHeader();
      pdf.setFont('helvetica', 'bold'); pdf.setFontSize(16); pdf.setTextColor(textColor);

      const alias = { chartTitle: dataset.label, yAxis: dataset.label };

      // console.log('alias',alias)
      // console.log('dataset',dataset)


      const metricTitle = alias.chartTitle;  
      const fullTitle = metricTitle ? `${chartTitle} - ${metricTitle} ` : chartTitle;
      pdf.text(fullTitle, pageWidth / 2, 75, { align: 'center' });


      // const metricTitle = dataset?.label ? `${mainTitle} — ${dataset.label}` : mainTitle;
      // pdf.text(metricTitle, pageWidth / 2, 75, { align: 'center' });


      // 2) leyenda de una sola métrica
      const legendBoxX = pageWidth * 0.1 - PAD;
      const legendBoxY = 95;
      const containerWidth = pageWidth * 0.8 + PAD * 2;
      const containerHeight = 38;
      pdf.setFillColor(darkModePDF ? '#2b2b2b' : '#f5f5f5');
      pdf.setDrawColor(darkModePDF ? '#444' : '#cccccc');
      pdf.roundedRect(legendBoxX, legendBoxY, containerWidth, containerHeight, 6, 6, 'FD');
      const [r, g, b] = normalizeColor(dataset.backgroundColor);
      pdf.setFillColor(r, g, b);
      pdf.rect(legendBoxX + PAD, legendBoxY + 12, 12, 12, 'F');
      pdf.setTextColor(darkModePDF ? '#fff' : '#000');
      pdf.setFontSize(10);
      pdf.text(dataset.label || 'Métrica', legendBoxX + PAD + 18, legendBoxY + 22);

      // 3) gráfico temporal (solo esa métrica)
      // const oneData = filterChartDataForPDF({
      //   labels: allLabels,
      //   datasets: [{ ...dataset, yAxisID: 'y' }],
      // });
      const labelsSorted = [...(allLabels || [])].sort((a, b) => {
        if (!isNaN(a) && !isNaN(b)) return Number(a) - Number(b);
        return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
      });

      const oneData = filterChartDataForPDF({
        labels: labelsSorted,
        datasets: [{ ...dataset, yAxisID: 'y' }],
      });

      if (!chart.canvas) {
        console.warn("Chart no tiene canvas, usando tamaño por defecto");
      }
      const GRAPH_HEIGHT_FACTOR = 0.55; // 👈 controlas aquí qué tan bajo será el gráfico

      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = chart.canvas.width || 800;
      tempCanvas.height = (chart.canvas?.height || 300) * GRAPH_HEIGHT_FACTOR;

      const tempCtx = tempCanvas.getContext('2d');

      const tmp = new Chart(tempCtx, {
        type: 'bar',
        data: {
          ...oneData,
          datasets: (oneData.datasets || []).map(ds => ({
            ...ds,
            backgroundColor: typeof ds.backgroundColor === 'string'
              ? ds.backgroundColor.replace(/[\d.]+\)$/g, '1)')
              : ds.backgroundColor,
          })),
        },
        options: {
          responsive: false,
          animation: false,
          plugins: { legend: { display: false }, tooltip: { enabled: false } },
          scales: {
            x: {
              title: { display: true, text: invert ? 'Jaulas' : 'Fechas', color: axisColor, font: { size: 12, weight: 'bold' } },
              ticks: { color: axisColor },
              grid: { color: gridColor },
            },
            y: {
              title: { display: true, text: 'SFR [ % ]', color: axisColor, font: { size: 12, weight: 'bold' } },
              ticks: { color: axisColor },
              grid: { color: gridColor },
            },
          },
        },
        plugins: [horizontalLinePlugin],
      });

      await new Promise(r => setTimeout(r, 150));
      const imgData = tempCanvas.toDataURL('image/png');
      tmp.destroy();

      // marco + imagen
      const imgWidth = pageWidth * 0.8;
      const imgHeight = tempCanvas.height * (imgWidth / tempCanvas.width);
      const posX = (pageWidth - imgWidth) / 2;
      const posY = legendBoxY + containerHeight + 20;

      pdf.setFillColor(darkModePDF ? '#2b2b2b' : '#f5f5f5');
      pdf.setDrawColor(darkModePDF ? '#444444' : '#cccccc');
      pdf.roundedRect(posX - PAD, posY - PAD, imgWidth + PAD * 2, imgHeight + PAD * 2, 6, 6, 'FD');
      pdf.addImage(imgData, 'PNG', posX, posY, imgWidth, imgHeight);



// 4) tablas en cuadrícula debajo del gráfico
// === CONFIGURACIÓN ===
const ROWS_PER_TABLE = opts.rowsPerTable || 9;  // 👈 Parametrizable (ej: 9 filas por tabla)
const MAX_COLS_PER_PAGE = opts.maxColsPerPage || 5; // 👈 Parametrizable (ej: 4 tablas por página)
const marginX = 40;
const gapX = 12;

// === FUNCIÓN PARA VALOR ===
const valueAt = (lbl) => {
  const idx = (filteredAllData.labels || []).indexOf(lbl);
  if (idx === -1) return '';
  const v = Array.isArray(dataset.data) ? dataset.data[idx] : undefined;
  return (v && typeof v === 'object') ? v.y : v;
};

// === ARMAR BODY COMPLETO ===
const head = [[invert ? 'Jaulas' : 'Fechas', 'Valor']];
const allRows = labelsSorted.map(lbl => [lbl, valueAt(lbl)]);

// === DIVIDIR EN BLOQUES DE N FILAS ===
const chunks = [];
for (let i = 0; i < allRows.length; i += ROWS_PER_TABLE) {
  chunks.push(allRows.slice(i, i + ROWS_PER_TABLE));
}

// === RENDERIZAR EN COLUMNAS (HORIZONTAL) ===
let remaining = [...chunks];
let startY = posY + imgHeight + 24; // 👈 debajo del gráfico

while (remaining.length > 0) {
  // Calcular cuántas columnas caben en esta página
  const colsThisPage = Math.min(MAX_COLS_PER_PAGE, remaining.length);

  // Ancho por tabla
  const totalTablesW = pageWidth - marginX * 2 - gapX * (colsThisPage - 1);
  const tableW = totalTablesW / colsThisPage;

  let x = marginX;
  // colores sugeridos para dark
  const DARK_BODY = [43, 43, 43];
  const DARK_BORDER = [200, 200, 200];
  const LIGHT_BODY = [255, 255, 255];

  // Dibujar tablas lado a lado
  for (let c = 0; c < colsThisPage; c++) {
    const body = remaining.shift(); // saco un bloque de 9 filas

    autoTable(pdf, {
      head,
      body,
      startY,
      margin: { left: x, right: marginX, top: 0, bottom: 0 },
      tableWidth: tableW,
      theme: 'grid',
      pageBreak: 'avoid',
      styles: {
        fontSize: 8,
        halign: 'center',
        valign: 'middle',
        lineWidth: 0.25,
        // lineColor: darkModePDF ? '#ffffff' : '#000000',
        // textColor: darkModePDF ? '#ffffff' : textColor,
        lineColor: darkModePDF ? DARK_BORDER : [0, 0, 0],
        textColor: darkModePDF ? [255, 255, 255] : [0, 0, 0],
        fillColor: darkModePDF ? undefined : LIGHT_BODY,
      },
      headStyles: { fillColor: '#e84e0e', textColor: '#ffffff', halign: 'center' },

      bodyStyles: {
        fillColor: darkModePDF ? undefined : LIGHT_BODY,
        textColor: darkModePDF ? [255, 255, 255] : [0, 0, 0],
      },

      // willDrawPage: () => { if (darkModePDF) paintBG(); paintHeader(); },
    });

    x += tableW + gapX;
  }

  // 👉 Si aún quedan más tablas, paso a una nueva página
  if (remaining.length > 0) {
    pdf.addPage();
    paintBG();
    paintHeader();
    startY = HEADER_HEIGHT + 28; // 👈 arranque para páginas siguientes
  }
}



    };

    // ---- Flujo principal ----
    if (!splitByMetric) {
      // modo legacy: todo en 1 gráfico (si lo quieres conservar)
      await paintMetricBlock(
        { label: title, data: (filteredAllData.labels || []).map(() => null), backgroundColor: 'rgba(0,0,0,0)' },
        filteredAllData.labels,
        title
      );
      if (onProgress) onProgress(100); // solo 1 bloque
    } else {

      const totalDatasets = datasetsForPDF.length; 
      for (let i = 0; i < datasetsForPDF.length; i++) {
        await paintMetricBlock(datasetsForPDF[i], filteredAllData.labels, title);
         // 👇 reportar progreso
        if (onProgress) {
          const percent = Math?.round(((i + 1) / totalDatasets) * 100);
          onProgress(percent);
        }
        if (i < datasetsForPDF.length - 1) pdf.addPage();
      }
    }

    // ---- numeración de páginas ----
    const total = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= total; i++) {
      pdf.setPage(i);
      pdf.setFont('helvetica', 'normal'); pdf.setFontSize(10); pdf.setTextColor(textColor);
      pdf.text(`${i} / ${total}`, pageWidth - 40, pageHeight - 24, { align: 'right' });
    }

    pdf.save(fileName);
  } catch (err) {
    console.error('Error en exportToPDF:', err);
  }
}



// export async function exportToPDF(chart, opts = {}) {
//   if (!chart) { console.error('exportToPDF: chart null'); return; }

//   const {
//     darkModePDF = false,
//     title,
//     invert = true,
//     splitByMetric = true,             // un gráfico por métrica (legacy)
//     generalCombined = false,          // 👈 NUEVO: 1 gráfico con todas las métricas + 2 tablas por grupo (dataset.title)
//     respectVisibility = true,
//     visibleDatasetLabels = [],
//     fileName = 'Reporte_por_metrica.pdf',
//     pdfOrientation = 'landscape',
//     metricResolver,
//     rowsPerTable = 9,
//     maxColsPerPage = 5,
//     allLabels
//   } = opts;

//   const MAX_COLUMNS = invert ? 12 : 24;
//   const HEADER_HEIGHT = 60;
//   const PAD = 12;

//   try {
//     // ---- Logos según modo ----
//     const itg = isElectron() ? `${window.location.origin}/images/ITG_BLANCO.png`
//                              : process.env.PUBLIC_URL + `/images/ITG_BLANCO.png`;
//     const itgNegro = isElectron() ? `${window.location.origin}/images/ITG-Logo-Negro.png`
//                                   : process.env.PUBLIC_URL + `/images/ITG-Logo-Negro.png`;
//     const scapp = isElectron() ? `${window.location.origin}/images/logo_scapp_blanco.png`
//                                : process.env.PUBLIC_URL + `/images/logo_scapp_blanco.png`;
//     const scappNegro = isElectron() ? `${window.location.origin}/images/logo_scapp_negro.png`
//                                     : process.env.PUBLIC_URL + `/images/logo_scapp_negro.png`;

//     const logoITGPath = darkModePDF ? itg : itgNegro;
//     const logoSCAPPPath = darkModePDF ? scapp : scappNegro;

//     const [logoITG, logoSCAPP] = await Promise.all([
//       loadImageBase64(logoITGPath),
//       loadImageBase64(logoSCAPPPath),
//     ]);

//     // ---- Datos del chart ----
//     const originalData = chart?.config?.data || {};
//     const filteredAllData = filterChartDataForPDF(originalData);

//     // ---- Selección de datasets (según visibilidad) ----
//     let datasetsForPDF = filteredAllData.datasets || [];
//     if (respectVisibility && Array.isArray(visibleDatasetLabels) && visibleDatasetLabels.length) {
//       const allow = new Set(visibleDatasetLabels);
//       const onlyVisible = datasetsForPDF.filter(ds => allow.has(ds.label));
//       if (onlyVisible.length) datasetsForPDF = onlyVisible;
//     }
//     if (!datasetsForPDF.length) datasetsForPDF = filteredAllData.datasets || [];

//     // ---- PDF base ----
//     const pdf = new jsPDF({ orientation: pdfOrientation, unit: 'pt', format: 'a4' });
//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();
//     const pageBackground = darkModePDF ? '#1e1e1e' : '#ffffff';
//     const textColor = darkModePDF ? '#ffffff' : '#000000';
//     const gridColor = darkModePDF ? '#444444' : 'rgba(0,0,0,0.3)';
//     const axisColor = darkModePDF ? '#ffffff' : '#000000';

//     const paintBG = () => { pdf.setFillColor(pageBackground); pdf.rect(0, 0, pageWidth, pageHeight, 'F'); };
//     const paintHeader = () => {
//       const itgW = 70, scappW = 120;
//       const itgY = (HEADER_HEIGHT - 40) / 2;
//       const scappY = (HEADER_HEIGHT - 30) / 2 + 9;
//       pdf.addImage(logoITG, 'PNG', 40, itgY, itgW, 0);
//       pdf.addImage(logoSCAPP, 'PNG', pageWidth - scappW - 40, scappY, scappW, 0);
//     };

//     const getMetricInfo = (ds) => {
//       const chartTitle = ds.title || ds.metricName || ds.label || 'Métrica';
//       const yAxis = ds.unit || ds.yLabel || ds.metricName || ds.label || 'Valor';
//       return { chartTitle, yAxis };
//     };

//     // =========== UTILIDADES ===========
//     const labelsSorted = [...(allLabels || filteredAllData.labels || [])].sort((a, b) => {
//       if (!isNaN(a) && !isNaN(b)) return Number(a) - Number(b);
//       return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
//     });

//     const DARK_BODY = [43, 43, 43];
//     const DARK_BORDER = [200, 200, 200];
//     const LIGHT_BODY = [255, 255, 255];

//     const valueAt = (dataset, lbl) => {
//       const idx = (filteredAllData.labels || []).indexOf(lbl);
//       if (idx === -1) return '';
//       const v = Array.isArray(dataset.data) ? dataset.data[idx] : undefined;
//       return (v && typeof v === 'object') ? v.y : v;
//     };

//     const groupByTitle = (dsets) => {
//       const map = new Map();
//       for (const ds of dsets) {
//         const key = ds.title || 'Grupo sin título';
//         if (!map.has(key)) map.set(key, []);
//         map.get(key).push(ds);
//       }
//       return map;
//     };

//     const renderLegendMulti = (datasets) => {
//       const legendBoxX = pageWidth * 0.1 - PAD;
//       const legendBoxY = 95;
//       const perRow = 7; // 👈 máximo 7 columnas por fila
//       const rowH = 16;
//       const innerPad = 10;

//       const rows = Math.ceil(datasets.length / perRow);
//       const boxH = rows * rowH + innerPad * 2;
//       const containerWidth = pageWidth * 0.8 + PAD * 2;

//       pdf.setFillColor(darkModePDF ? '#2b2b2b' : '#f5f5f5');
//       pdf.setDrawColor(darkModePDF ? '#444' : '#cccccc');
//       pdf.roundedRect(legendBoxX, legendBoxY, containerWidth, boxH, 6, 6, 'FD');

//       let y = legendBoxY + innerPad + 4;
//       pdf.setFontSize(10);
//       datasets.forEach((ds, i) => {
//         const col = i % perRow;
//         const row = Math.floor(i / perRow);
//         const x = legendBoxX + PAD + col * (containerWidth / perRow);
//         const yy = y + row * rowH;

//         const [r, g, b] = normalizeColor(ds.backgroundColor);
//         pdf.setFillColor(r, g, b);
//         pdf.rect(x, yy - 10, 12, 12, 'F');
//         pdf.setTextColor(darkModePDF ? '#fff' : '#000');
//         pdf.text(`${ds.label}${ds.unit ? ` (${ds.unit})` : ''}`, x + 18, yy);
//       });

//       return { legendY: legendBoxY, legendH: boxH };
//     };


//     // =========== BLOQUE POR MÉTRICA (como ya tenías) ===========
//     const paintMetricBlock = async (dataset) => {
//       const { chartTitle, yAxis } = getMetricInfo(dataset);

//       paintBG(); paintHeader();
//       pdf.setFont('helvetica', 'bold'); pdf.setFontSize(16); pdf.setTextColor(textColor);

//       const metricTitle = dataset.label;
//       const fullTitle = metricTitle ? `${chartTitle} - ${metricTitle}` : chartTitle;
//       pdf.text(fullTitle, pageWidth / 2, 75, { align: 'center' });

//       // Leyenda simple
//       const legendBoxX = pageWidth * 0.1 - PAD;
//       const legendBoxY = 95;
//       const containerWidth = pageWidth * 0.8 + PAD * 2;
//       const containerHeight = 38;
//       pdf.setFillColor(darkModePDF ? '#2b2b2b' : '#f5f5f5');
//       pdf.setDrawColor(darkModePDF ? '#444' : '#cccccc');
//       pdf.roundedRect(legendBoxX, legendBoxY, containerWidth, containerHeight, 6, 6, 'FD');
//       const [r, g, b] = normalizeColor(dataset.backgroundColor);
//       pdf.setFillColor(r, g, b);
//       pdf.rect(legendBoxX + PAD, legendBoxY + 12, 12, 12, 'F');
//       pdf.setTextColor(darkModePDF ? '#fff' : '#000');
//       pdf.setFontSize(10);
//       pdf.text(dataset.label || 'Métrica', legendBoxX + PAD + 18, legendBoxY + 22);

//       // Gráfico de una métrica
//       const oneData = filterChartDataForPDF({
//         labels: labelsSorted,
//         datasets: [{ ...dataset, yAxisID: 'y' }],
//       });

//       const GRAPH_HEIGHT_FACTOR = 0.55;
//       const tempCanvas = document.createElement('canvas');
//       tempCanvas.width = chart.canvas?.width || 800;
//       tempCanvas.height = (chart.canvas?.height || 300) * GRAPH_HEIGHT_FACTOR;

//       const tempCtx = tempCanvas.getContext('2d');
//       const tmp = new Chart(tempCtx, {
//         type: 'bar',
//         data: {
//           ...oneData,
//           datasets: (oneData.datasets || []).map(ds => ({
//             ...ds,
//             backgroundColor: typeof ds.backgroundColor === 'string'
//               ? ds.backgroundColor.replace(/[\d.]+\)$/g, '1)')
//               : ds.backgroundColor,
//           })),
//         },
//         options: {
//           responsive: false,
//           animation: false,
//           plugins: { legend: { display: false }, tooltip: { enabled: false } },
//           scales: {
//             x: {
//               title: { display: true, text: invert ? 'Jaulas' : 'Fechas', color: axisColor, font: { size: 12, weight: 'bold' } },
//               ticks: { color: axisColor },
//               grid: { color: gridColor },
//             },
//             y: {
//               title: { display: false, text: yAxis, color: axisColor, font: { size: 12, weight: 'bold' } },
//               ticks: { color: axisColor },
//               grid: { color: gridColor },
//             },
//           },
//         },
//       });

//       await new Promise(r => setTimeout(r, 150));
//       const imgData = tempCanvas.toDataURL('image/png');
//       tmp.destroy();

//       const imgWidth = pageWidth * 0.8;
//       const imgHeight = tempCanvas.height * (imgWidth / tempCanvas.width);
//       const posX = (pageWidth - imgWidth) / 2;
//       const posY = legendBoxY + containerHeight + 20;

//       pdf.setFillColor(darkModePDF ? '#2b2b2b' : '#f5f5f5');
//       pdf.setDrawColor(darkModePDF ? '#444444' : '#cccccc');
//       pdf.roundedRect(posX - PAD, posY - PAD, imgWidth + PAD * 2, imgHeight + PAD * 2, 6, 6, 'FD');
//       pdf.addImage(imgData, 'PNG', posX, posY, imgWidth, imgHeight);

//       // === Tablas (en columnas, como ya tenías) ===
//       const head = [[invert ? 'Jaulas' : 'Fechas', 'Valor']];
//       const allRows = labelsSorted.map(lbl => [lbl, valueAt(dataset, lbl)]);

//       // dividir en bloques de rowsPerTable
//       const chunks = [];
//       for (let i = 0; i < allRows.length; i += rowsPerTable) {
//         chunks.push(allRows.slice(i, i + rowsPerTable));
//       }

//       let remaining = [...chunks];
//       let startY = posY + imgHeight + 24;
//       const marginX = 40;
//       const gapX = 12;

//       while (remaining.length > 0) {
//         const colsThisPage = Math.min(maxColsPerPage, remaining.length);
//         const totalTablesW = pageWidth - marginX * 2 - gapX * (colsThisPage - 1);
//         const tableW = totalTablesW / colsThisPage;

//         let x = marginX;

//         for (let c = 0; c < colsThisPage; c++) {
//           const body = remaining.shift();

//           autoTable(pdf, {
//             head,
//             body,
//             startY,
//             margin: { left: x, right: marginX, top: 0, bottom: 0 },
//             tableWidth: tableW,
//             theme: 'grid',
//             pageBreak: 'avoid',
//             styles: {
//               fontSize: 8,
//               halign: 'center',
//               valign: 'middle',
//               lineWidth: 0.25,
//               lineColor: darkModePDF ? DARK_BORDER : [0, 0, 0],
//               textColor: darkModePDF ? [255, 255, 255] : [0, 0, 0],
//               fillColor: darkModePDF ? undefined : LIGHT_BODY,
//             },
//             headStyles: { fillColor: '#e84e0e', textColor: '#ffffff', halign: 'center' },
//             bodyStyles: {
//               fillColor: darkModePDF ? undefined : LIGHT_BODY,
//               textColor: darkModePDF ? [255, 255, 255] : [0, 0, 0],
//             },
//           });

//           x += tableW + gapX;
//         }

//         if (remaining.length > 0) {
//           pdf.addPage(); paintBG(); paintHeader();
//           startY = HEADER_HEIGHT + 28;
//         }
//       }
//     };

//     // =========== BLOQUE GENERAL (1 gráfico + 2 tablas por grupo) ===========
//     const paintGeneralCombined = async () => {
//       paintBG(); paintHeader();

//       // Título
//       const mainTitle = title || 'Reporte General';
//       pdf.setFont('helvetica', 'bold'); pdf.setFontSize(16); pdf.setTextColor(textColor);
//       pdf.text(mainTitle, pageWidth / 2, 75, { align: 'center' });

//       // Leyenda múltiple
//       const { legendY, legendH } = renderLegendMulti(datasetsForPDF);

//       // Gráfico combinando TODAS las métricas
//       const mixedData = filterChartDataForPDF({
//         labels: labelsSorted,
//         datasets: datasetsForPDF.map(ds => ({
//           ...ds,
//           yAxisID: 'y',
//           backgroundColor: typeof ds.backgroundColor === 'string'
//             ? ds.backgroundColor.replace(/[\d.]+\)$/g, '1)')
//             : ds.backgroundColor,
//         })),
//       });

//       const GRAPH_HEIGHT_FACTOR = 0.5;
//       const tempCanvas = document.createElement('canvas');
//       tempCanvas.width = chart.canvas?.width || 1000;
//       tempCanvas.height = (chart.canvas?.height || 320) * GRAPH_HEIGHT_FACTOR;

//       const tempCtx = tempCanvas.getContext('2d');
//       const tmp = new Chart(tempCtx, {
//         type: 'bar', // puedes cambiarlo a 'line' si prefieres
//         data: mixedData,
//         options: {
//           responsive: false,
//           animation: false,
//           plugins: { legend: { display: false }, tooltip: { enabled: false } },
//           scales: {
//             x: {
//               title: { display: true, text: invert ? 'Jaulas' : 'Fechas', color: axisColor, font: { size: 12, weight: 'bold' } },
//               ticks: { color: axisColor },
//               grid: { color: gridColor },
//             },
//             y: {
//               title: { display: false, text: 'Valor', color: axisColor, font: { size: 12, weight: 'bold' } },
//               ticks: { color: axisColor },
//               grid: { color: gridColor },
//             },
//           },
//         },
//       });

//       await new Promise(r => setTimeout(r, 150));
//       const imgData = tempCanvas.toDataURL('image/png');
//       tmp.destroy();

//       const imgWidth = pageWidth * 0.8;
//       const imgHeight = tempCanvas.height * (imgWidth / tempCanvas.width);
//       const posX = (pageWidth - imgWidth) / 2;
//       const posY = legendY + legendH + 20;

//       pdf.setFillColor(darkModePDF ? '#2b2b2b' : '#f5f5f5');
//       pdf.setDrawColor(darkModePDF ? '#444444' : '#cccccc');
//       pdf.roundedRect(posX - PAD, posY - PAD, imgWidth + PAD * 2, imgHeight + PAD * 2, 6, 6, 'FD');
//       pdf.addImage(imgData, 'PNG', posX, posY, imgWidth, imgHeight);

//       // ====== TABLAS POR GRUPO (dataset.title) ======
//       // ====== TABLAS POR GRUPO (dataset.title) ======
//       const groups = Array.from(groupByTitle(datasetsForPDF).entries()); 
//       const groupsToShow = groups.slice(0, 2);

//       // 👉 forzar nueva página SOLO para tablas
//       pdf.addPage();
//       paintBG(); paintHeader();

//       let startY = HEADER_HEIGHT + 40;
//       const marginX = 40;
//       const contentW = pageWidth - marginX * 2;

//       for (let gi = 0; gi < groupsToShow.length; gi++) {
//         const [groupTitle, dsets] = groupsToShow[gi];

//         // Extraer año del primer label
//         const firstYearMatch = String(labelsSorted[0]).match(/\d{4}$/);
//         const yearText = firstYearMatch ? ` — ${firstYearMatch[0]}` : "";

//         // Título de la tabla
//         pdf.setFont('helvetica', 'bold');
//         pdf.setFontSize(12);
//         pdf.setTextColor(textColor);
//         pdf.text(groupTitle + yearText, marginX, startY);

//         const headRow = [invert ? 'Jaulas' : 'Fechas', ...dsets.map(ds => ds.label)];
//         const head = [headRow];

//         const body = labelsSorted.map(lbl => {
//           const lblSinAnio = String(lbl).replace(/[-/.]?\d{4}$/, "");
//           const row = [lblSinAnio];
//           for (const ds of dsets) row.push(valueAt(ds, lbl));
//           return row;
//         });

//         autoTable(pdf, {
//           head,
//           body,
//           startY: startY + 6,
//           margin: { left: marginX, right: marginX },
//           tableWidth: contentW,
//           theme: 'grid',
//           pageBreak: 'auto',
//           styles: {
//             fontSize: 8,
//             halign: 'center',
//             valign: 'middle',
//             lineWidth: 0.25,
//             lineColor: darkModePDF ? DARK_BORDER : [0, 0, 0],
//             textColor: darkModePDF ? [255, 255, 255] : [0, 0, 0],
//             fillColor: darkModePDF ? undefined : LIGHT_BODY, // 👈 sin fondo blanco en dark
//           },
//           headStyles: { fillColor: '#e84e0e', textColor: '#ffffff', halign: 'center' },
//           bodyStyles: {
//             fillColor: darkModePDF ? undefined : LIGHT_BODY,
//             textColor: darkModePDF ? [255, 255, 255] : [0, 0, 0],
//           },
//           didDrawPage: (data) => {
//             if (data.pageNumber > 1) { paintBG(); paintHeader(); }
//           }
//         });

//         // preparar posición para el siguiente grupo
//         startY = (pdf.lastAutoTable?.finalY || (startY + 6)) + 18;
//       }

//     };

//     // ---- Flujo principal ----
//     if (generalCombined) {
//       await paintGeneralCombined();
//     } else if (!splitByMetric) {
//       // modo legacy: 1 gráfico placeholder + tablas
//       await paintMetricBlock(
//         { label: title, data: (filteredAllData.labels || []).map(() => null), backgroundColor: 'rgba(0,0,0,0)' }
//       );
//     } else {
//       for (let i = 0; i < datasetsForPDF.length; i++) {
//         await paintMetricBlock(datasetsForPDF[i]);
//         if (i < datasetsForPDF.length - 1) pdf.addPage();
//       }
//     }

//     // ---- numeración de páginas ----
//     const total = pdf.internal.getNumberOfPages();
//     for (let i = 1; i <= total; i++) {
//       pdf.setPage(i);
//       pdf.setFont('helvetica', 'normal'); pdf.setFontSize(10); pdf.setTextColor(textColor);
//       pdf.text(`${i} / ${total}`, pageWidth - 40, pageHeight - 24, { align: 'right' });
//     }

//     pdf.save(generalCombined ? (opts.fileName || 'Reporte_general.pdf') : fileName);
//   } catch (err) {
//     console.error('Error en exportToPDF:', err);
//   }
// }